import { render, staticRenderFns } from "./TabRealisasi.vue?vue&type=template&id=137c4c2a&scoped=true"
import script from "./TabRealisasi.vue?vue&type=script&lang=js"
export * from "./TabRealisasi.vue?vue&type=script&lang=js"
import style0 from "./TabRealisasi.vue?vue&type=style&index=0&id=137c4c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137c4c2a",
  null
  
)

export default component.exports